<template>
  <div class="pi-insights">
    <p v-if="!items.length" class="pi-insights__empty">{{ emptyText }}</p>
    <ul v-else class="pi-insights__list">
      <li v-for="(item, index) in items" :key="item.id || 'pi-insight-' + index" class="pi-insight" :class="{ 'is-seen': !item.open }">
        <div class="pi-insight__head">
          <strong class="pi-insight__title">{{ item.title }}</strong>
          <span class="pi-badge" :class="item.open ? 'pi-badge--warn' : 'pi-badge--muted'">{{ item.statusText }}</span>
        </div>
        <p v-if="item.observation" class="pi-insight__text">
          <span class="pi-insight__label">Observação:</span> {{ item.observation }}
        </p>
        <p v-if="item.hypothesis" class="pi-insight__text">
          <span class="pi-insight__label">Hipótese:</span> {{ item.hypothesis }}
        </p>
        <p v-if="item.nextStep" class="pi-insight__text">
          <span class="pi-insight__label">Próxima investigação:</span> {{ item.nextStep }}
        </p>
        <p v-if="item.metaText" class="pi-insight__meta">{{ item.metaText }}</p>
        <div class="pi-insight__actions">
          <router-link v-if="item.route" :to="item.route" class="pi-link">Abrir a visão filtrada</router-link>
          <span v-if="item.company && item.companyName" class="pi-insight__company">
            Empresa: <pi-company-name :company-id="item.companyId" :shard-code="item.shardCode" :name="item.companyName"/>
          </span>
          <router-link v-else-if="item.company" :to="item.company" class="pi-link">Abrir a empresa (banco {{ item.shardCode }})</router-link>
          <button v-if="item.open && item.id" type="button" class="pi-btn pi-btn--ghost" :disabled="item.busy"
                  @click="ack(item)">{{ item.busy ? 'Marcando…' : 'Marcar como visto' }}</button>
          <span v-if="item.error" class="pi-insight__error" role="alert">{{ item.error }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import piCompanyName from "./piCompanyName.vue";
import { ackInsight, errorMessage } from "./piApi.js";
import { insightView } from "./piInsights.js";
import { companyLink } from "./piNavigation.js";

export default {
  name: "pi-insight-list",
  components: { piCompanyName },
  props: {
    insights: { type: Array, default: () => [] },
    emptyText: { type: String, default: "Nenhum insight aberto no período." },
    companyLinks: { type: Boolean, default: false },
  },
  data() {
    return {
      overrides: {},
    };
  },
  computed: {
    items() {
      return (this.insights || []).filter(Boolean).map((insight) => {
        const id = insight.id === undefined || insight.id === null ? "" : String(insight.id);
        const shardCode = typeof insight.shardCode === "string" ? insight.shardCode.trim() : "";
        const companyId = typeof insight.companyId === "string" ? insight.companyId.trim() : "";
        const company = this.companyLinks ? companyLink(companyId, shardCode, this.$route ? this.$route.query : {}) : null;
        return Object.assign(insightView(insight, this.overrides[id]), { company: company, companyId: companyId, shardCode: shardCode });
      });
    },
  },
  methods: {
    setOverride(id, patch) {
      const current = this.overrides[id] || {};
      this.$set(this.overrides, id, Object.assign({}, current, patch));
    },
    ack(item) {
      if (item.busy) return;
      this.setOverride(item.id, { busy: true, error: "" });
      ackInsight(item.id)
        .then((status) => {
          this.setOverride(item.id, { busy: false, status: status });
          this.$emit("acked", { id: item.id, status: status });
        })
        .catch((error) => {
          this.setOverride(item.id, { busy: false, error: errorMessage(error, "marcar o insight como visto") });
        });
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-insights__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pi-insight {
  margin-bottom: 10px;
  padding: 12px 14px;
  border: 1px solid #e6e7eb;
  border-left: 4px solid #e6a700;
  border-radius: 6px;
  background: #ffffff;
}

.pi-insight.is-seen {
  border-left-color: #c5cad3;
  background: #fafbfc;
}

.pi-insight__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 6px 12px;
  margin-bottom: 6px;
}

.pi-insight__title {
  font-size: 13px;
  color: #1f2933;
}

.pi-insight__text {
  margin: 0 0 4px;
  font-size: 12px;
  color: #3a424e;
}

.pi-insight__label {
  font-weight: 700;
}

.pi-insight__meta {
  margin: 4px 0 8px;
  font-size: 11px;
  color: #6b7280;
}

.pi-insight__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
}

.pi-insight__company {
  font-size: 13px;
  color: #3a424e;
}

.pi-insight__error {
  font-size: 12px;
  color: #a3172b;
}

.pi-insights__empty {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piInsightList.vue